<template>
  <div class="user-sessions-list">
    <v-row>
      <v-text-field v-model='search' :readonly='!startSearching' @focus='startSearching = true' label='Search' outlined class='searchbox'></v-text-field>
      <v-btn large text rounded outlined class='searchbtn'>Submit</v-btn>
    </v-row>
    <v-list v-for='(session, index) in filteredSessions' :key='index'>
      <list-session-item :name='session.sessionName' :creator='session.creator' :type='session.sessionType' :id='session._id' source='user_page' />
    </v-list>

    <v-expansion-panels multiple focusable>
      <v-expansion-panel>
        <v-expansion-panel-header expand-icon='fa-angle-down'><h1>ARCHIVED SESSIONS</h1></v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-list v-for='(session, index) in archivedSessions' :key='index'>
            <list-session-item :name='session.sessionName' :creator='session.creator' :type='session.sessionType' :id='session._id' source='user_page_archived' />
          </v-list>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    If you forgot your session pasword then you need to ask the creator to enter the session and reset it from there<br/>
    <!-- TODO: fix above problems. ie, add a sessions search endpoint with pagination and a forgot password endpoint with auth -->
  </div>
</template>

<script>
import ListSessionItem from '@/components/ListSessionItem'
import UsersService from '@/services/UsersService'
export default {
  name: 'user-sessions-list',
  data () {
    return {
      search: '',
      startSearching: false,
      sessions: []
    }
  },
  methods: {
  },
  async created () {
    if (this.$store.state.globalAuthToken === '') {
      alert('You must be logged in to list your sessions')
      this.$router.push({ path: `/` })
      return
    }
    var response = await UsersService.fetchSessions({
      globalAuthToken: this.$store.state.globalAuthToken,
      solverId: this.$store.state.solverId
    })
    if (response.data.success) {
      this.sessions = response.data.sessions
      this.sessions.reverse()
    } else {
      alert('Error: ' + response.data.error)
    }
  },
  computed: {
    filteredSessions () {
      return this.sessions.filter(v => (v.sessionName.includes(this.search) && !v.archived))
    },
    archivedSessions () {
      return this.sessions.filter(v => (v.archived))
    }
  },
  components: {
    ListSessionItem
  }
}
</script>

<style scoped>
.searchbox {
  padding: 0 20px !important;
}
.searchbtn {
  margin-right: 40px !important;
}
</style>
